import { PollStatus } from '@tribeplatform/react-sdk/types'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'

import { T } from '../i18n/index.js'

export function PollStatusBadge({ status }: { status: PollStatus }) {
  switch (status) {
    case PollStatus.Active:
      return (
        <Badge variant="highlight">
          <T id="Poll.Status.Live" defaultMessage="Live" />
        </Badge>
      )
    case PollStatus.Scheduled:
      return (
        <Badge variant="highlight">
          <T id="Poll.Status.Scheduled" defaultMessage="Scheduled" />
        </Badge>
      )
    case PollStatus.Closed:
      return (
        <Badge variant="negative">
          <T id="Poll.Status.Closed" defaultMessage="Closed" />
        </Badge>
      )
    default:
      return null
  }
}
